(function(){
  function hexToHsl(hex){
    if(!hex) return {h:220,s:18,l:96};
    let c = hex.replace('#','');
    if(c.length===3){ c = c.split('').map(ch=>ch+ch).join(''); }
    const r = parseInt(c.substr(0,2),16)/255;
    const g = parseInt(c.substr(2,2),16)/255;
    const b = parseInt(c.substr(4,2),16)/255;
    const max = Math.max(r,g,b), min = Math.min(r,g,b);
    let h, s, l = (max + min) / 2;
    if(max === min){ h = s = 0; }
    else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch(max){
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60; h = h % 360;
    }
    return { h: Math.round(h||0), s: Math.round((s||0)*100), l: Math.round((l||0)*100) };
  }

  function getVisible(){
    const w = window.innerWidth;
    if(w >= 1024) return 3; if(w >= 768) return 2; return 1;
  }

  function initSection(section){
    const viewport = section.querySelector('[data-pc-viewport]');
    const track = section.querySelector('[data-pc-track]');
    const titleEl = section.querySelector('[data-pc-title]');
    const ctaEl = section.querySelector('[data-pc-cta]');
    const prevBtn = section.querySelector('[data-pc-prev]');
    const nextBtn = section.querySelector('[data-pc-next]');

    if(!viewport || !track) return;

    let slides = Array.from(track.children);
    const total = slides.length;
    if(total === 0) return;

    // Preload images to avoid flicker when looping
    try {
      slides.forEach(s => {
        s.querySelectorAll('img').forEach(img => {
          const src = img.getAttribute('src') || img.getAttribute('data-src');
          if(src){
            const im = new Image();
            im.src = src;
          }
        });
      });
    } catch(e){}

    // Clone up to 3 slides each side for seamless loop
    const CLONES = Math.min(3, total);
    const leftClones = slides.slice(-CLONES).map(n=>n.cloneNode(true));
    const rightClones = slides.slice(0, CLONES).map(n=>n.cloneNode(true));

    leftClones.forEach(n=>track.insertBefore(n, track.firstChild));
    rightClones.forEach(n=>track.appendChild(n));

    const allSlides = Array.from(track.children);
    let offset = CLONES; // starting offset
    let currentLeftIndex = 0; // left-most visible index in real slides
    let visualIndex = offset + currentLeftIndex; // index in allSlides
    let visible = getVisible();
    let slideW = 0;

    function measure(){
      visible = getVisible();
      // Ensure exact number of slides per viewport (1/2/3) with no half slides
      slideW = viewport.clientWidth / visible;
      allSlides.forEach(s => {
        s.style.flex = `0 0 ${100/visible}%`;
        s.style.maxWidth = `${100/visible}%`;
      });
      // Position without anim when measuring to avoid flicker
      setTranslate(true);
      updateUI();
    }

    function setTranslate(noAnim){
      if(noAnim){ track.style.transition = 'none'; }
      const x = Math.round(-visualIndex * slideW);
      track.style.transform = `translate3d(${x}px,0,0)`;
      if(noAnim){
        // force reflow to apply no-transition instantly
        void track.offsetHeight;
        track.style.transition = '';
      }
    }

    function centerOffset(){ return Math.floor((getVisible()-1)/2); }

    function applyThemeFrom(centerEl){
      if(!centerEl) return;
      const hex = centerEl.getAttribute('data-color');
      const hsl = hexToHsl(hex);
      section.style.setProperty('--pc-h', hsl.h);
      section.style.setProperty('--pc-s', hsl.s + '%');
      section.style.setProperty('--pc-l', hsl.l + '%');
      section.style.setProperty('--pc-s-dim', `calc(${hsl.s}% - 8%)`);
      section.style.setProperty('--pc-l-dim', `calc(${hsl.l}% - 6%)`);
      section.style.setProperty('--pc-l-deep', `calc(${hsl.l}% - 14%)`);

      // Update title and CTA
      const t = centerEl.getAttribute('data-title') || '';
      const link = centerEl.getAttribute('data-link') || '#';
      if(titleEl) titleEl.textContent = t;
      if(ctaEl) ctaEl.setAttribute('href', link);
    }

    function markRoles(vIndex = visualIndex){
      allSlides.forEach(s=>{
        s.classList.remove('is-center','is-left','is-right');
      });
      const cOff = centerOffset();
      const centerIdx = vIndex + cOff;
      const leftIdx = centerIdx - 1;
      const rightIdx = centerIdx + 1;
      const get = (i) => allSlides[i];
      const centerEl = get(centerIdx);
      const leftEl = get(leftIdx);
      const rightEl = get(rightIdx);
      if(leftEl) leftEl.classList.add('is-left');
      if(centerEl) centerEl.classList.add('is-center');
      if(rightEl) rightEl.classList.add('is-right');
      applyThemeFrom(centerEl);
    }

    function updateUI(){
      markRoles();
    }

    let isSliding = false;
    function getCenterFromPredicted(pred){ return allSlides[pred + centerOffset()]; }
    function ensureImageReady(centerEl){
      return new Promise((resolve)=>{
        if(!centerEl) return resolve();
        const img = centerEl.querySelector('img');
        if(!img) return resolve();
        img.setAttribute('loading','eager');
        const done = () => resolve();
        if(img.complete && img.naturalWidth > 0){
          if(typeof img.decode === 'function'){
            img.decode().then(done).catch(done);
          } else {
            done();
          }
        } else {
          function onL(){ img.removeEventListener('load', onL); done(); }
          function onE(){ img.removeEventListener('error', onE); done(); }
          img.addEventListener('load', onL);
          img.addEventListener('error', onE);
        }
      });
    }

    function next(){
      if(isSliding) return;
      const predicted = visualIndex + 1;
      const targetCenter = getCenterFromPredicted(predicted);
      isSliding = true;
      ensureImageReady(targetCenter).then(function(){
        markRoles(predicted);
        visualIndex = predicted; currentLeftIndex = (currentLeftIndex + 1) % total;
        setTranslate();
      });
    }
    function prev(){
      if(isSliding) return;
      const predicted = visualIndex - 1;
      const targetCenter = getCenterFromPredicted(predicted);
      isSliding = true;
      ensureImageReady(targetCenter).then(function(){
        markRoles(predicted);
        visualIndex = predicted; currentLeftIndex = (currentLeftIndex - 1 + total) % total;
        setTranslate();
      });
    }

    track.addEventListener('transitionend', function(){
      let wrapped = false;
      if(visualIndex >= offset + total){
        visualIndex = offset + (visualIndex - (offset + total));
        setTranslate(true);
        wrapped = true;
      }
      if(visualIndex < offset){
        visualIndex = offset + total - (offset - visualIndex);
        setTranslate(true);
        wrapped = true;
      }
      if(wrapped){
        updateUI();
      }
      isSliding = false;
    });

    // Buttons
    if(prevBtn) prevBtn.addEventListener('click', prev);
    if(nextBtn) nextBtn.addEventListener('click', next);

    // Swipe / drag
    let startX = 0, deltaX = 0, dragging = false;
    const threshold = 30;
    function onDown(e){ dragging = true; startX = (e.touches? e.touches[0].clientX : e.clientX); deltaX = 0; }
    function onMove(e){ if(!dragging) return; const x = (e.touches? e.touches[0].clientX : e.clientX); deltaX = x - startX; }
    function onUp(){ if(!dragging) return; dragging = false; if(Math.abs(deltaX) > threshold){ if(deltaX < 0) next(); else prev(); } }

    viewport.addEventListener('mousedown', onDown); window.addEventListener('mousemove', onMove); window.addEventListener('mouseup', onUp);
    viewport.addEventListener('touchstart', onDown, {passive:true}); viewport.addEventListener('touchmove', onMove, {passive:true}); viewport.addEventListener('touchend', onUp);

    window.addEventListener('resize', function(){
      const prevVisible = visible;
      const prevCenterOff = Math.floor((prevVisible - 1) / 2);
      measure();
      const newCenterOff = centerOffset();
      // keep visual center stable when layout changes
      if(prevVisible !== visible){
        visualIndex += (prevCenterOff - newCenterOff);
        setTranslate(true);
        updateUI();
      }
    });

    // Initial measurement and theme
    measure();
    // Start so that the first real product is centered
    visualIndex = visualIndex - centerOffset();
    // Jump to starting offset position without animation
    setTranslate(true);
    updateUI();
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[id^="pc-"]').forEach(initSection);
  });
})();
